import { ILocation } from "../interfaces/common/location";
import { ShopLocationType } from "../interfaces/delivery-company/pickups";

export const displayLocation = (location?: ILocation | ShopLocationType | null): string => {
    if (location == null) return "No Location"
    const parts: string[] = [location.area?.name_en, location.area?.name_ar,  location.area?.district, location.directions].filter(item => item != undefined) as string[]
    return parts.filter(item => item != undefined && item.length > 0).join(", ")
}

export const displayMultipleLocations = (locations: ILocation[] | ShopLocationType[]): string => {
    if (!locations || locations.length === 0) return "No locations available"
    if (locations.length === 1) return displayLocation(locations[0])
    return `${displayLocation(locations[0])} (and ${locations.length - 1} more)`
}

export const extractMapsPlaceLink = (location?: ILocation | ShopLocationType | null) => {
    if (location == null) return ""
    if (!location.place_id || location.place_id.length == 0) return ""
    return `https://www.google.com/maps/embed/v1/place?q=place_id:${location.place_id}&key=AIzaSyBEJaG3Jk2B4Hpe5_YiUk8IDf06ut64rZs`
}